var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_support"},[_c('div',{staticClass:"support_title"},[_vm._v(" FAQ ")]),_c('section',{staticClass:"container-1200 layui-fluid",staticStyle:{"min-height":"555px"}},[_c('FaqList')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }